import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import styles from "./Discount.module.scss";
import DiscountIcon from "../../components/icons/discount/discountIcon";
import CopyIcon from "../../components/icons/discount/copy";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import SmallDiscount from "../../components/icons/discount/smallDiscount";
import { useAppSelector } from "../../store/store";
import { Subscription } from "../../types";
import useSubscriptions from "../../hooks/useSubscriptions";
import ModalWrapper from "../../components/shared/ModalWrapper/ModalWrapper";
import ChangeSubModal from "../profile/components/ChangeSubModal";
import { useDispatch } from "react-redux";
import { setLoginModal, setOpenModal } from "../../store/slices/modals.slice";
import LoginModal from "../../components/shared/LoginModal/LoginModal";
import useWindowSize from "../../hooks/useWindowSize";
import classNames from "classnames";

import discountBg from "./assets/discountbg.jpg";

type data = { [key: string]: { [key: string]: string | boolean | number }[] };
const dataTranslations: data = {
  uk: [
    {
      id: 0,
      mounts: "Безкоштовно",
      costs: "0",
      continue: "далі",
      point1: "1 000 трейлерів в підборі",
      point1Positive: false,
      point2: "З рекламою",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "1 місяць",
      costs: "49",
      continue: "далі",
      point1: "Без знижки",
      point1Positive: false,
      point2: "100 000 трейлерів в підборі",
      point2Positive: true,
      point3: "Без реклами",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "1 рік",
      costs: "549",
      continue: "далі",
      point1: "Знижка 25%",
      point1Positive: true,
      point2: "100 000 трейлерів в підборі",
      point2Positive: true,
      point3: "Без реклами",
      point3Positive: true,
      showDiscount: true,
    },
  ],
  ru: [
    {
      id: 0,
      mounts: "Бесплатно",
      costs: "0",
      continue: "далее",
      point1: "1 000 трейлеров в подборке",
      point1Positive: false,
      point2: "С рекламой",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "1 месяц",
      costs: "49",
      continue: "далее",
      point1: "Без скидки",
      point1Positive: false,
      point2: "100 000 трейлеров в подборке",
      point2Positive: true,
      point3: "Без рекламы",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "1 год",
      costs: "549",
      continue: "далее",
      point1: "Скидка 25%",
      point1Positive: true,
      point2: "100 000 трейлеров в подборке",
      point2Positive: true,
      point3: "Без рекламы",
      point3Positive: true,
      showDiscount: true,
    },
  ],
  en: [
    {
      id: 0,
      mounts: "Free",
      costs: "0",
      continue: "then",
      point1: "1,000 trailers in selection",
      point1Positive: false,
      point2: "With ads",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "1 month",
      costs: "4.99",
      continue: "then",
      point1: "No discount",
      point1Positive: false,
      point2: "100,000 trailers in selection",
      point2Positive: true,
      point3: "No ads",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "1 year",
      costs: "54.99",
      continue: "then",
      point1: "25% discount",
      point1Positive: true,
      point2: "100,000 trailers in selection",
      point2Positive: true,
      point3: "No ads",
      point3Positive: true,
      showDiscount: true,
    },
  ],
  ar: [
    {
      id: 0,
      mounts: "مجاني",
      costs: "0",
      continue: "ثم 12.99",
      point1: "1,000 مقطع دعائي في التحديد",
      point1Positive: false,
      point2: "مع الإعلانات",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "شهر واحد",
      costs: "15.99",
      continue: "ثم 10.99",
      point1: "بدون خصم",
      point1Positive: false,
      point2: "100,000 مقطع دعائي في التحديد",
      point2Positive: true,
      point3: "بدون إعلانات",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "سنة واحدة",
      costs: "149.99",
      continue: "ثم 199.99",
      point1: "خصم 25%",
      point1Positive: true,
      point2: "100,000 مقطع دعائي في التحديد",
      point2Positive: true,
      point3: "بدون إعلانات",
      point3Positive: true,
      showDiscount: true,
    },
  ],
  fr: [
    {
      id: 0,
      mounts: "Gratuit",
      costs: "0",
      continue: "puis",
      point1: "1 000 bandes-annonces dans la sélection",
      point1Positive: false,
      point2: "Avec publicités",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "1 mois",
      costs: "4.99",
      continue: "puis",
      point1: "Sans réduction",
      point1Positive: false,
      point2: "100 000 bandes-annonces dans la sélection",
      point2Positive: true,
      point3: "Sans publicités",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "1 an",
      costs: "54.99",
      continue: "puis",
      point1: "Réduction de 25%",
      point1Positive: true,
      point2: "100 000 bandes-annonces dans la sélection",
      point2Positive: true,
      point3: "Sans publicités",
      point3Positive: true,
      showDiscount: true,
    },
  ],
  es: [
    {
      id: 0,
      mounts: "Gratis",
      costs: "0",
      continue: "luego",
      point1: "1,000 tráilers en la selección",
      point1Positive: false,
      point2: "Con anuncios",
      point2Positive: false,
      point3: "",
      showDiscount: false,
    },
    {
      id: 1,
      mounts: "1 mes",
      costs: "4.99",
      continue: "luego",
      point1: "Sin descuento",
      point1Positive: false,
      point2: "100,000 tráilers en la selección",
      point2Positive: true,
      point3: "Sin anuncios",
      point3Positive: true,
      showDiscount: false,
    },
    {
      id: 2,
      mounts: "1 año",
      costs: "54.99",
      continue: "luego",
      point1: "Descuento del 25%",
      point1Positive: true,
      point2: "100,000 tráilers en la selección",
      point2Positive: true,
      point3: "Sin anuncios",
      point3Positive: true,
      showDiscount: true,
    },
  ],
};

const btnTitleHandler = (index: number, userData: any, t: any) => {
  if (index === 1) {
    return userData?.has_monthly_subscription ? t("active") : t("connect");
  }

  if (index === 2) {
    return userData?.has_yearly_subscription ? t("active") : t("connect");
  }

  if (index === 0) {
    return t("active");
  }
};

const btnClassHandler = (index: number, userData: any) => {
  if (index === 1) {
    return userData?.has_monthly_subscription ? styles.activeButton : "";
  }

  if (index === 2) {
    return userData?.has_yearly_subscription ? styles.activeButton : "";
  }

  if (index === 0) {
    return styles.activeButton;
  }
};
const Discount = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { subscribe } = useSubscriptions();
  const userData = useAppSelector((state: any) => state.auth.userData);
  const { modal, loginModal } = useAppSelector((state: any) => state.modals);
  const { windowSize } = useWindowSize();

  const [subsData, setSubsData] = useState(dataTranslations);
  const [priceUpToDate, setPriceUpToDate] = useState<boolean>(false);

  const subscriptionsList = useAppSelector((state: any) => state.subscriptions.subscriptionsList);

  useEffect(() => {
    if (subscriptionsList.length) {
      setSubsData((prevState) => {
        const data = prevState;

        subscriptionsList.forEach((item: Subscription) => {
          if (item?.billing_period === "month") {
            data["ru"][1].costs = `${item?.price}`;
            data["uk"][1].costs = `${item?.price}`;
            data["en"][1].costs = `${item?.price}`;
            data["ar"][1].costs = `${item?.price}`;
            data["fr"][1].costs = `${item?.price}`;
            data["es"][1].costs = `${item?.price}`;
          }

          if (item.billing_period === "year") {
            data["ru"][2].costs = `${item?.price}`;
            data["uk"][2].costs = `${item?.price}`;
            data["en"][2].costs = `${item?.price}`;
            data["ar"][2].costs = `${item?.price}`;
            data["fr"][2].costs = `${item?.price}`;
            data["es"][2].costs = `${item?.price}`;
          }
        });

        setPriceUpToDate(true);
        return data;
      });
    }
  }, [subscriptionsList]);

  const [openModal, setOpenModalLoc] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";
  const offerWithDate = `${t("offerTo")} ${windowSize === "mobile" ? "22.02.2025" : "22.02.2027"}`;
  const aiLabelMap: Record<string, string> = {
    uk: "Ai рекомендації",
    en: "AI recommendations",
    ar: "توصيات Ai",
    ru: "Ai рекомендации",
    fr: "Recommandations IA",
    es: "Recomendaciones IA",
  };
  const aiLabel = aiLabelMap[i18n.language] || "AI recommendations";
  const featureRows = [
    { label: t("compTrailers"), key: "trailers" },
    { label: t("compAds"), key: "ads" },
    { label: t("compFilters"), key: "filters" },
    { label: aiLabel, key: "ai" },
  ];
  const planFeatures = [
    {
      trailers: { value: "1 000", highlight: false },
      ads: false,
      filters: false,
      ai: false,
    },
    {
      trailers: { value: "100 000", highlight: true },
      ads: true,
      filters: true,
      ai: true,
    },
    {
      trailers: { value: "100 000", highlight: true },
      ads: true,
      filters: true,
      ai: true,
    },
  ];

  return (
    <div className={styles.discountPageWrapper} style={{ backgroundImage: `url(${discountBg})` }}>
      <Header className={`${styles.headerDiscount} ${isScrolled ? styles.headerBlurred : ""}`} />
      <div className={styles.discountContent}>
        <div className={styles.iconWrapper}>
          <DiscountIcon />
        </div>
        <div className={styles.discountTitle}>{t("discountTitle")}</div>
        <div className={styles.discountDescription}>{offerWithDate}</div>
        <div className={styles.cards}>
          {subsData[i18n.language || "en"].map((item, index) => {
            if ((userData?.has_monthly_subscription || userData?.has_yearly_subscription) && item.id === 0) {
              return <></>;
            }
            return (
              <div
                dir={dirData}
                key={index}
                className={classNames(styles.cardWrapper, item.id === 0 ? styles.freePlan : styles.premiumPlan)}
              >
                <div className={styles.cardCosts}>
                  <div className={styles.planHead}>
                    <span>{item.mounts}</span>
                    <span className={styles.planMonthly}>
                      {item.id === 2
                        ? `${+(+item.costs / 12).toFixed(2)}`
                        : `${priceUpToDate ? (+item.costs).toFixed(2) : "..."}`}
                      {t("perMonth")}
                    </span>
                  </div>
                  <div className={styles.planPriceBlock}>
                    <span className={styles.planPrice}>
                      {priceUpToDate ? item.costs : "..."}
                      <span className={styles.costCurrency}> $</span>
                    </span>
                    {item.showDiscount && (
                      <div className={styles.discountBadge}>
                        <SmallDiscount />
                        <span>{item.point1}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className={styles.cardDivider} />
                <div className={styles.cardPointsList}>
                  <div className={styles.featuresList}>
                    {featureRows.map((feature) => {
                      const currentPlanData: any = planFeatures[index] || planFeatures[0];
                      const featureValue = currentPlanData[feature.key as keyof typeof currentPlanData];

                      return (
                        <div dir={dirData} className={styles.planPointItem} key={feature.key}>
                          <span>{feature.label}</span>
                          <div className={styles.planPointValue}>
                            {feature.key === "trailers" ? (
                              <span className={featureValue.highlight ? styles.highlightValue : styles.mutedValue}>
                                {featureValue.value}
                              </span>
                            ) : featureValue ? (
                              <span className={`${styles.planMark} ${styles.planMarkPositive}`}>✓</span>
                            ) : (
                              <span className={`${styles.planMark} ${styles.planMarkNegative}`}>×</span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    onClick={() => {
                      if (item.id === 1 && userData?.has_yearly_subscription) {
                        dispatch(setOpenModal("changeSub"));
                        return;
                      }

                      if (item.id === 2 && userData?.has_monthly_subscription) {
                        dispatch(setOpenModal("changeSub"));
                        return;
                      }
                      if (!localStorage.getItem("accessToken")) {
                        dispatch(setLoginModal(true));
                      } else {
                        subscribe(item.id as number);
                      }
                    }}
                    className={`${styles.cardButton} ${btnClassHandler(index, userData)}`}
                  >
                    {btnTitleHandler(index, userData, t)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer source={""} />
      {openModal && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <div className={styles.textWrapper}>
              <div className={styles.modalTitle}>{t("linkModal")}</div>
              <div className={styles.modalDescription}>https://hiviewer.ai/Y6xZa9Hn6pV</div>
            </div>
            <div onClick={() => setOpenModalLoc(false)}>
              <CopyIcon />
            </div>
          </div>
        </div>
      )}
      {modal && <ModalWrapper>{modal === "changeSub" && <ChangeSubModal />}</ModalWrapper>}
      {loginModal && <LoginModal />}
    </div>
  );
};

export default Discount;
